var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-select',{attrs:{"allow-clear":false,"filter-option":false,"label-in-value":true,"options":_vm.options,"show-search":true,"disabled":_vm.disabled},on:{"change":_vm.change,"popupScroll":_vm.popupScroll,"search":_vm.search},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }